import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Linkedin, Instagram } from 'lucide-react';

// TikTok icon component (not available in lucide-react)
const TikTokIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
    </svg>
);

export const Footer = () => {
    return (
        <footer className="bg-neutral-900 text-neutral-300">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div className="col-span-1">
                        <Link to="/" className="flex items-center gap-2 mb-4">
                            <div className="w-9 h-9 rounded-lg bg-primary-600 flex items-center justify-center">
                                <MapPin className="w-5 h-5 text-white" />
                            </div>
                            <span className="font-heading font-bold text-xl text-white">
                                RecruitNearMe
                            </span>
                        </Link>
                        <p className="text-sm text-neutral-400 mb-4">
                            Find recruiters near you and get real humans to help you apply and win interviews.
                        </p>
                        <div className="flex gap-3">
                            <a 
                                href="https://www.linkedin.com/company/recruitnearme" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="p-2 rounded-lg bg-neutral-800 hover:bg-neutral-700 transition-colors"
                                aria-label="LinkedIn"
                            >
                                <Linkedin className="w-5 h-5" />
                            </a>
                            <a 
                                href="https://www.instagram.com/recruitnearme" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="p-2 rounded-lg bg-neutral-800 hover:bg-neutral-700 transition-colors"
                                aria-label="Instagram"
                            >
                                <Instagram className="w-5 h-5" />
                            </a>
                            <a 
                                href="https://www.tiktok.com/@recruitnearme" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="p-2 rounded-lg bg-neutral-800 hover:bg-neutral-700 transition-colors"
                                aria-label="TikTok"
                            >
                                <TikTokIcon className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="font-heading font-semibold text-white mb-4">Services</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/agencies" className="text-sm hover:text-white transition-colors">
                                    Find Recruiters
                                </Link>
                            </li>
                            <li>
                                <Link to="/multi-apply" className="text-sm hover:text-white transition-colors">
                                    Multi-Apply
                                </Link>
                            </li>
                            <li>
                                <Link to="/consultation" className="text-sm hover:text-white transition-colors">
                                    Consultation
                                </Link>
                            </li>
                            <li>
                                <Link to="/pricing" className="text-sm hover:text-white transition-colors">
                                    Pricing
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog" className="text-sm hover:text-white transition-colors">
                                    Blog
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Company */}
                    <div>
                        <h3 className="font-heading font-semibold text-white mb-4">Legal</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/privacy" className="text-sm hover:text-white transition-colors">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms" className="text-sm hover:text-white transition-colors">
                                    Terms & Conditions
                                </Link>
                            </li>
                            <li>
                                <Link to="/modern-slavery-statement" className="text-sm hover:text-white transition-colors">
                                    Modern Slavery Statement
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h3 className="font-heading font-semibold text-white mb-4">Contact</h3>
                        <ul className="space-y-3">
                            <li className="flex items-center gap-2 text-sm">
                                <Mail className="w-4 h-4 text-primary-500" />
                                <a href="mailto:support@recruitnearme.com" className="hover:text-white transition-colors">
                                    support@recruitnearme.com
                                </a>
                            </li>
                            <li className="flex items-start gap-2 text-sm">
                                <MapPin className="w-4 h-4 text-primary-500 mt-0.5" />
                                <span>71-75 Shelton Street<br />Covent Garden<br />London, UK</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-neutral-800 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-sm text-neutral-500">
                        &copy; {new Date().getFullYear()} RecruitNearMe. All rights reserved.
                    </p>
                    <p className="text-sm text-neutral-500">
                        Registered in England & Wales
                    </p>
                </div>
            </div>
        </footer>
    );
};
